export default __webpack_public_path__ + "static/media/F0002.3e74eca5.png";